import React from 'react';
import CardDataSourceFilters from 'components/CardDataSourceFilters';
import {selectIsFilterActive} from 'state/cardDetail/cardDetailSelectors';
import {connect} from 'react-redux';
import cx from 'classnames';
import './ExpandableCardFilters.css';
import {RpcContext, cleanFiltersForRpc} from 'components/RpcEndpoint';
import {selectFiltersByCardId} from 'state/cardFilter/cardFilterSelectors';
import {REMOTE} from '../../../../app/JsRpcConstants';

class ExpandableCardFilters extends React.Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    if (this.context != undefined && this.context.applyMethod != undefined) {
      const rcpFilters = cleanFiltersForRpc(this.props.filters);
      this.context.applyMethod(REMOTE.V1_ON_FILTERS_CHANGE, {
        filters: rcpFilters,
      });
    }
  }
  render() {
    return (
      <div
        className={cx({
          ExpandableCardFilters: true,
          'ExpandableCardFilters--active': this.props.active,
        })}
      >
        {this.props.active ? (
          <CardDataSourceFilters
            cardId={this.props.cardId}
            pageId={this.props.pageId}
          />
        ) : null}
      </div>
    );
  }
}

ExpandableCardFilters.contextType = RpcContext;

export default connect((state, {cardId}) => ({
  active: selectIsFilterActive(state),
  filters: selectFiltersByCardId(state, cardId),
}))(ExpandableCardFilters);
